// ============================================
// LINDERMAN — THEME JS (con menú móvil)
// ============================================

document.addEventListener('DOMContentLoaded', () => {

  // ---- MENÚ MÓVIL ----
  const menuBtn = document.getElementById('mobileMenuBtn');
  const mobileNav = document.getElementById('mobileNav');

  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', () => {
      const isOpen = mobileNav.classList.contains('open');
      if (isOpen) {
        mobileNav.classList.remove('open');
        menuBtn.classList.remove('active');
        menuBtn.setAttribute('aria-expanded', 'false');
        mobileNav.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      } else {
        mobileNav.classList.add('open');
        menuBtn.classList.add('active');
        menuBtn.setAttribute('aria-expanded', 'true');
        mobileNav.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
    });

    // Cerrar al hacer click en un link
    mobileNav.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        mobileNav.classList.remove('open');
        menuBtn.classList.remove('active');
        document.body.style.overflow = '';
      });
    });

    // Cerrar con Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileNav.classList.contains('open')) {
        mobileNav.classList.remove('open');
        menuBtn.classList.remove('active');
        document.body.style.overflow = '';
        menuBtn.focus();
      }
    });
  }

  // ---- GALERÍA DE PRODUCTO ----
  const thumbs = document.querySelectorAll('.product-thumb');
  const mainImg = document.getElementById('main-product-img');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      if (mainImg) mainImg.src = thumb.dataset.src;
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  // ---- TABS DE PRODUCTOS ----
  const tabs = document.querySelectorAll('.products-tab');
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
    });
  });

  // ---- HEADER SCROLL SHADOW ----
  const header = document.querySelector('.site-header');
  window.addEventListener('scroll', () => {
    if (header) {
      header.style.boxShadow = window.scrollY > 20
        ? '0 4px 40px rgba(0,0,0,0.6)'
        : 'none';
    }
  }, { passive: true });

  // ---- QUICK ADD TÁCTIL (móvil) ----
  if ('ontouchstart' in window) {
    document.querySelectorAll('.product-card').forEach(card => {
      card.addEventListener('touchstart', () => {
        document.querySelectorAll('.product-quick-add').forEach(btn => {
          btn.style.transform = 'translateY(100%)';
        });
        const btn = card.querySelector('.product-quick-add');
        if (btn) btn.style.transform = 'translateY(0)';
      }, { passive: true });
    });
  }

});
